import React from "react";
import styled from "styled-components";
import { media, mediaQueries } from "../theme";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";

const Wrapper = styled.div`
  position: relative;
  a {
    top: 50px;
    left: 20px;
    position: absolute;
    z-index: 2;
  }
  img {
    position: absolute;
  }
`;

const Error404 = () => {
  const isDesktop = useMedia(media.lg);
  return (
    <Wrapper>
      <Link to={"/"}>Retour à l'accueil</Link>
      <img
        className={"w-100"}
        src={isDesktop ? "/error_404.png" : "/error_404_mobile.png"}
        alt="erreur image"
      />
    </Wrapper>
  );
};

export default Error404;
